import { Target, Zap } from "lucide-react";

const EvaluationTab = ({ evaluationData }) => {

    return (<>
        <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500">
             <div>
                <h3 className="text-2xl font-bold text-slate-900 tracking-tight">AI Compliance Evaluation</h3>
                <p className="text-sm text-slate-500 mt-1">Automated scoring and anomaly detection based on evidence.</p>
              </div>
            <div className="grid grid-cols-1 gap-5">
              {evaluationData.map((evalItem) => (
                <div key={evalItem.id} className="p-6 bg-white ring-1 ring-slate-200/60 rounded-3xl shadow-sm flex flex-col md:flex-row items-center gap-8 hover:shadow-md transition-all">
                  
                  {/* Score Dial Emulation */}
                  <div className="shrink-0 relative flex items-center justify-center w-32 h-32 rounded-full ring-8 ring-slate-50 bg-white shadow-inner">
                     <svg className="absolute inset-0 w-full h-full transform -rotate-90">
                        <circle cx="64" cy="64" r="56" fill="transparent" stroke="#f1f5f9" strokeWidth="8" />
                        <circle cx="64" cy="64" r="56" fill="transparent" 
                           stroke={evalItem.score >= 90 ? '#10b981' : evalItem.score >= 70 ? '#f59e0b' : '#e11d48'} 
                           strokeWidth="8" 
                           strokeDasharray="351.8" 
                           strokeDashoffset={351.8 - (351.8 * evalItem.score) / 100} 
                           strokeLinecap="round" 
                           className="transition-all duration-1000 ease-out"
                        />
                     </svg>
                     <div className="flex flex-col items-center">
                        <span className="text-3xl font-black text-slate-800">{evalItem.score}</span>
                        <span className="text-[9px] font-bold text-slate-400 uppercase tracking-widest">Score</span>
                     </div>
                  </div>

                  <div className="flex-1 w-full space-y-4">
                    <div className="flex flex-wrap items-center gap-3">
                      <span className="text-sm font-bold text-indigo-700 bg-indigo-50 ring-1 ring-indigo-200/50 px-3 py-1.5 rounded-lg flex items-center gap-1.5"><Target size={14}/> Control {evalItem.control}</span>
                      <span className={`text-xs font-bold uppercase tracking-widest px-3 py-1.5 rounded-lg ring-1 ${evalItem.confidence === 'High' ? 'bg-emerald-50 text-emerald-700 ring-emerald-200/50' : 'bg-amber-50 text-amber-700 ring-amber-200/50'}`}>
                        {evalItem.confidence} Confidence
                      </span>
                    </div>
                    
                    <div className="bg-slate-50 p-4 rounded-xl ring-1 ring-slate-200/50 flex gap-3 items-start">
                      <Zap size={18} className="text-indigo-500 shrink-0 mt-0.5" />
                      <div>
                         <strong className="text-slate-900 text-xs font-bold uppercase tracking-widest block mb-1">AI Finding</strong> 
                         <p className="text-sm text-slate-600 font-medium leading-relaxed">{evalItem.finding}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
        </div>
    </>);
};

export default EvaluationTab;